import React from "react";
import { useForm } from "react-hook-form";
import { TitleH2 } from "../../../../shared/native/typography.styles";
import { PrimaryButton } from "../../../../shared/native/button.styles";
import { FormContainer, FormContent } from "../../../../shared/form/form.styles";
import {
  FieldDescription,
  FieldError,
  FieldInfo,
  FieldName,
} from "../../../../shared/form/fieldInfo.styles";
import { FieldData } from "../../../../shared/form/fieldData.styles";
import { Input } from "../../../../shared/native/input.styles";
import loading from "../../../../../core/types/loading";
import ChangePasswordForm from "../../interfaces/ChangePasswordForm";
import { changePasswordProfileFormRequest } from "../../../../../http/requests/profile.http";
import ResponseBody from "../../../../../http/models/ResponseBody";
import { Actions, ErrorText, Form, SuccessText } from "./changePasswordProfileForm.styles";

const ChangePasswordProfileForm: React.FC = () => {
  const [apiResponse, setApiResponse] = React.useState<ResponseBody<null> | null>(null);
  const [submitLoadingStatus, setSubmitLoadingStatus] = React.useState<loading>(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ChangePasswordForm>({
    values: {
      current_password: "",
      new_password1: "",
      new_password2: "",
    },
    mode: "onBlur",
  });

  const submitForm = (data: ChangePasswordForm): void => {
    setSubmitLoadingStatus("LOADING");

    changePasswordProfileFormRequest(data).then((res) => {
      setApiResponse(res.data);

      if (res.data.error) {
        setSubmitLoadingStatus("ERROR");
      } else {
        setSubmitLoadingStatus("COMPLETE");
        reset();
      }
    });
  };

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <TitleH2>Смена пароля</TitleH2>

      <FormContent>
        <FormContainer className="formContent">
          <FieldInfo>
            <FieldName>Текущий пароль</FieldName>
            {!!errors?.current_password && (
              <FieldError>{errors.current_password.message as string}</FieldError>
            )}
          </FieldInfo>
          <FieldData>
            <Input
              className="defaultInput"
              placeholder="Начните вводить"
              {...register("current_password", {
                required: "Обязательное поле",
              })}
            />
          </FieldData>

          <FieldInfo>
            <FieldName>Новый пароль</FieldName>
            <FieldDescription>
              Новый пароль должен состоять из букв латинского алфавита, цифр и символов (!#$%&*+)
            </FieldDescription>
            {!!errors?.new_password1 && (
              <FieldError>{errors.new_password1.message as string}</FieldError>
            )}
          </FieldInfo>
          <FieldData>
            <Input
              className="defaultInput"
              placeholder="Начните вводить"
              {...register("new_password1", {
                required: "Обязательное поле",
              })}
            />
          </FieldData>

          <FieldInfo>
            <FieldName>Повторите новый пароль</FieldName>
            {!!errors?.new_password2 && (
              <FieldError>{errors.new_password2.message as string}</FieldError>
            )}
          </FieldInfo>
          <FieldData>
            <Input
              className="defaultInput"
              placeholder="Начните вводить"
              {...register("new_password2", {
                required: "Обязательное поле",
              })}
            />
          </FieldData>

          {apiResponse && (
            <>
              <FieldInfo> </FieldInfo>

              {apiResponse.error ? (
                <ErrorText>{apiResponse.text}</ErrorText>
              ) : (
                <SuccessText>{apiResponse.text}</SuccessText>
              )}
            </>
          )}
        </FormContainer>
      </FormContent>

      <Actions>
        <PrimaryButton type="submit" disabled={submitLoadingStatus === "LOADING"}>
          Сохранить
        </PrimaryButton>
      </Actions>
    </Form>
  );
};

export default ChangePasswordProfileForm;
